import { IVanFetch } from 'src/models/IVan';

type IFilterVan = Pick<IVanFetch, 'id' | 'location' | 'make' | 'type' | 'year'>;

const createVanURL = (filter: IFilterVan) => {
  const location = filter.location.split(' - ');
  const state = location[0].replaceAll(' ', '');
  let city;
  if (location.length > 1) city = location[1].replaceAll(' ', '');
  else city = state;
  const make = filter.make ? filter.make.replaceAll(' ', '') : '-';
  const type = filter.type ? filter.type : '-';
  const year = filter.year ? filter.year : '-';

  return `/van/${state}/${city}/${make}/${type}/${year}/143${filter.id}`;
};

export default createVanURL;
